const translations = {
  'sform.title': 'Subscribe To Our Mailing List!',
  'sform.description': 'Receive course updates, graduate reviews, exclusive discounts and more',
  'sform.name.placeholder': 'Your name',
  'sform.email.placeholder': 'Your email',
  'sform.signUpNow': 'Sign Up Now',
};

export default translations;
